// removed by extract-text-webpack-plugin
module.exports = {"container":"_1X4awFr-UKmPRaD1c2StKQ","titleContainer":"_2fYgrx_29iOVFYfounNcAO","caret":"_1VBEyWm7PvjcYbeUCS51UA","collapsed":"_149XEJvYQgLjr_jL22W9AU","list":"_1iPFhL5YE9hnTLtqacv5UR","homesResult":"_21e4wfpUnQsx0wYr_4gL9U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageDropdown/LanguageDropdown.scss
// module id = 1614
// module chunks = 0